import React, { useEffect, useRef } from "react"
import { useInView } from "react-intersection-observer"
import { Flex } from "@theme-ui/components"
import MuxPlayer from "@mux/mux-player-react"

const VideoStream = ({ muxPlaybackId, customData, minHeight, aspectRatio }) => {
  const videoPlaceholder = `https://image.mux.com/${muxPlaybackId}/thumbnail.jpg?&time=0`
  console.log(muxPlaybackId, customData, videoPlaceholder)
  if (customData) {
    var isNotAutoplay = customData.autoplay === "false"
  }
  const playerRef = useRef(true)
  const [ref, inView] = useInView({
    threshold: 0.2,
  })
  useEffect(() => {
    console.log(inView, playerRef.current)
    const video = playerRef.current
    if (inView && !isNotAutoplay) {
      video.play()
    } else {
      video.pause()
    }
  }, [inView])

  return (
    <Flex
      ref={ref}
      sx={{
        width: "100%",
        height: minHeight,
        "mux-player": isNotAutoplay
          ? {}
          : {
              "--controls": "none",
              "--media-object-fit": "cover",
              "--media-object-position": "center",
            },
      }}
    >
      <MuxPlayer
        style={{
          height: "100%",
          maxWidth: "100%",
          aspectRatio: aspectRatio ? aspectRatio : null,
        }}
        id={muxPlaybackId}
        playbackId={muxPlaybackId}
        streamType="on-demand"
        playsInline
        preload="auto"
        muted={!isNotAutoplay}
        loop={!isNotAutoplay}
        ref={playerRef}
        poster={videoPlaceholder}
        placeholder={videoPlaceholder}
      />
    </Flex>
  )
}

export default VideoStream
